import Vue from "vue/dist/vue.esm.js";
/**============================================================
*   [gnav]
*   description : グローバルナビの処理を記述
============================================================*/

document.addEventListener('DOMContentLoaded', function() {
  if(document.getElementById('vue-gnav')){
    const gnav = new Vue({
      el: '#vue-gnav',
      data () {
        return {
          isGnavOpened: false,
          categoryNum: 0,
          isSP: (function(){
            var mql = window.matchMedia("(min-width: 768px)");
            if (mql.matches) {
              return false;
            }else{
              return true;
            }
          })(),
          currentSpMode: false,
        }
      },
      mounted: function(){
        if (!this.isSP) {
          this.isGnavOpened = true;
        }
        //ブレイクポイント時に初期化
        window.addEventListener('resize', function(){
          gnav.setIsSP();
          if(gnav.isSP != gnav.currentSpMode){
            gnav.resetGnav();
          }
        });

        //キャッシュによる表示のリセット対策
        window.onbeforeunload = function() {};
        window.onunload = function() {};
        window.addEventListener("pageshow", function(event){
          if (event.persisted) {
            if (gnav.isSP) {
              gnav.resetGnav();
            }
          }
        });
      },
      methods: {
        isCategorySelect: function(num,event) {
          let currentNum = this.categoryNum;
          var eTarget = event.srcElement.closest('.l-gnav__list__item__category');
          this.setIsSP();
          if(event.type == "mouseenter"){
            if (!this.isSP) {
              if(currentNum == num){
                this.categoryNum = 0;
              }else{
                this.categoryNum = num;
              }
            }
          }else if(event.type == "mouseleave"){
            if (!this.isSP) {
              this.categoryNum = 0;
            }
          }else{
            if (this.isSP) {
              if(currentNum == num){
                this.categoryNum = 0;
                if(eTarget) {
                  eTarget.classList.remove('is-opened');
                }
              }else{
                this.categoryNum = num;
                if(eTarget) {
                  eTarget.classList.add('is-opened');
                }
              }
            }
          }
        },
        isToggleGnav: function(){
          if(this.isGnavOpened){
            this.isGnavOpened = false;
            document.documentElement.classList.remove('ov-hidden');
          }else{
            this.isGnavOpened = true;
            document.documentElement.classList.add('ov-hidden');
          }
        },
        isGnavClose: function(){
          this.categoryNum = 0;
          this.isGnavOpened = false;
          document.documentElement.classList.remove('ov-hidden');
        },
        resetGnav: function(){
          this.setIsSP();

          //ブラウザバック時のみ、アニメーションを切る
          $(".l-gnav__container").addClass("no-animation");

          if(this.isSP){
            //SP時のデフォルト状態
            this.isGnavClose();
          }else{
            //PC時のデフォルト状態
            this.categoryNum = 0;
            this.isGnavOpened = true;
            document.documentElement.classList.remove('ov-hidden');
          }
          this.currentSpMode = this.isSP;
        },
        setIsSP: function(){
          var mql = window.matchMedia("(min-width: 767px)");
          if (mql.matches) {
            this.isSP = false;
          }else{
            this.isSP = true;
          }
        },
        //[SP]高さ変更でアコーディオンさせる処理
        beforeEnter: function(el) {
          this.setIsSP();
          if (this.isSP) {
            el.style.height = '0' + 'px';
          }else{
            el.style.height = '';
          }
        },
        enter: function(el) {
          this.setIsSP();
          if (this.isSP) {
            el.style.height = el.scrollHeight + 'px';
          }else{
            el.style.height = '';
          }
        },
        beforeLeave: function(el) {
          this.setIsSP();
          if (this.isSP) {
            el.style.height = el.scrollHeight + 'px';
          }else{
            el.style.height = '';
          }
        },
        leave: function(el) {
          this.setIsSP();
          if (this.isSP) {
            el.style.height = '0' + 'px';
          }else{
            el.style.height = '';
          }
        },
        transitionLeave: function(){
          $(".l-gnav__container").removeClass("no-animation");
        }
      }
    })
  }
})
